export const MOCK_EMAIL_RESPONSE = {
    errorCode: 0,
    errorDescription: 'SUCCESS',
    errorMessage: null,
    response: [{
        emailSeqNum: 2,
        emailAddress: 'PABLO.P@PERSHING.COM',
        oldEmailAddress: null,
        emailIndex: 0
    }, {
        emailSeqNum: 3,
        emailAddress: 'PABLO.P2@PERSHING.COM',
        oldEmailAddress: null,
        emailIndex: 0
    }]
};
